export default __webpack_public_path__ + "media/components/AdEdit/images/google-visit-btn-671154cde9339bca892a2ff98ddf8738.png";